import { Box, Text, Stack, Group, Progress, Divider } from "@mantine/core";

type Props = {
  percent: number;
  answered: number;
  total: number;
  remaining: number;
};

export default function AssessmentProgressPanel({ percent, answered, total, remaining }: Props) {
  return (
    <Box
      p="md"
      style={{
        backgroundColor: "#ffffff",
        borderTop: "1px solid var(--mantine-color-slate-2)",
      }}
    >
      <Text fw={700} fz="sm" c="dark.7" mb="sm">
        Your Progress
      </Text>

      <Stack gap={4} mb="md">
        <Group justify="space-between" align="baseline" wrap="nowrap">
          <Text fw={700} fz="xl" c="primary.8" lh={1.1}>
            {percent}%
          </Text>
          <Text fz="xs" c="slate.5">
            Complete
          </Text>
        </Group>
        <Progress
          value={percent}
          size={6}
          radius="xl"
          styles={{
            root: { backgroundColor: "var(--mantine-color-primary-1)" },
            section: { backgroundColor: "var(--mantine-color-primary-6)" },
          }}
          aria-label="Overall progress"
        />
      </Stack>

      <Divider color="var(--mantine-color-slate-2)" mb="sm" />

      <Stack gap={8}>
        <Group justify="space-between" align="center" wrap="nowrap">
          <Text fz="xs" c="slate.6">
            Answered
          </Text>
          <Text fz="sm" fw={600} c="primary.8">
            {answered} / {total}
          </Text>
        </Group>
        <Group justify="space-between" align="center" wrap="nowrap">
          <Text fz="xs" c="slate.6">
            Remaining
          </Text>
          <Text fz="sm" fw={600} c="primary.8">
            {remaining}
          </Text>
        </Group>
      </Stack>
    </Box>
  );
}
